import * as React from 'react';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  Icon,
  type IIconProps,
  cn,
} from '@kognitos/lattice';
import { useTranslation } from 'react-i18next';

interface IAccessDeniedProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Icon to display. Defaults to CircleSlash2 */
  icon?: IIconProps['type'];

  /** Title text. Defaults to "Access denied" */
  title?: string;

  /** Description text. Defaults to "You don't have permission to view this content" */
  description?: string;

  /** Whether to show a dashed border. Defaults to true */
  bordered?: boolean;

  /** Ref to the container element */
  ref?: React.Ref<HTMLDivElement>;
}

const AccessDenied = ({
  ref,
  className,
  bordered = true,
  icon = 'CircleAlert',
  title,
  description,
  ...props
}: IAccessDeniedProps) => {
  const { t: tCommon } = useTranslation('common');
  return (
    <Empty
      ref={ref}
      className={cn(className, bordered && 'border border-dashed rounded-lg')}
      {...props}
    >
      <EmptyMedia variant="icon">
        <Icon type={icon} />
      </EmptyMedia>

      <EmptyHeader>
        <EmptyTitle>{title || tCommon('common.accessDenied.title')}</EmptyTitle>
        <EmptyDescription>
          <p>{description || tCommon('common.accessDenied.subtitle')}</p>
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};

AccessDenied.displayName = 'AccessDenied';

export { AccessDenied, type IAccessDeniedProps };
